<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="APM">
<h1 class="chapter" id="pz15-1" style="text-align: center;">
					Foreword<br/>
<b>Jan and Richard Hughes</b></h1>
<br/>
<h2 id="pz15-2">
					HEAR MY VOICE </h2>
<h3 id="pz15-3">
					Jan Hughes </h3>
<br/>
<p id="pz15-4" style="text-indent: 0">
					Most of us have memories of the various preachers who graced the pulpits of our home
					congregations. But from the time I was born until the time I left for college, I
					knew only one preacher. I heard only one voice. It was the voice of my father. </p>
<p id="pz15-5">
					My parents had four daughters: Dana, Marilyn, Janice, and Sara, spaced approximately
					three years apart, and I was number three. My father was proud of his girls, but
					with each birth he hoped for a boy, a son to follow in his footsteps. A Timothy to
					his Paul. But it was not to be. </p>
<p id="pz15-6">
					During my days of growing up, life was somewhat predictable. Our household was rather
					structured, as were the families of most of my friends. Our daddies went to work.
					Our mothers stayed at home. Most of us planned to do the same when our time came.
					And if we dared to dream of a career, it was pretty much limited to teaching or nursing—and
					then, only until a child was born. </p>
<p id="pz15-7">
					The same was true at church. The roles were carefully defined, though usually unspoken.
					The men preached, led singing, served communion, offered prayers, and some served
					as elders or deacons. The women taught the Sunday school classes, organized and taught
					vacation Bible school, and prepared food for potlucks. If women taught or prayed,
					it was only with young children or with other women. Even when we “played church”
					on our back porch steps, we always sat in the congregation, singing our hearts out,
					but never speaking. </p>
<p id="pz16-1">
					One by one, each of my sisters married. Each one of us formed homes that partially
					reflected the home in which we had grown up. And each of us was also very involved
					in the activities of our home congregation. Two of us, in particular, began to move
					beyond the teaching of our children and began to devote significant time to teaching
					our peers, usually in the format of what was called “ladies’ Bible class.” </p>
<p id="pz16-2">
					When we moved to Pepperdine in 1988, I began to have expanded opportunities, and
					I found myself speaking to both men and women. First, I was asked to co-teach the
					Sunday morning college class with my husband, Richard. Next, I was invited to speak
					on the Pepperdine lectureship program. I was then asked to speak in Daybreak Chapel
					for Pepperdine faculty and staff and at a Wednesday-night college care group. Another
					semester, Richard and I co-taught a Sunday morning adult Bible class on the Upside-Down
					Kingdom. Next, I was part of a rotation of teachers of a Sunday-morning adult class.
					I continued to have other invitations to speak on the lectureship and later had several
					opportunities to share my lectureship presentations with adult classes at the Malibu
					congregation. I was also invited to speak at women’s retreats in Malibu and beyond.
					Many doors opened, and I walked through. </p>
<p id="pz16-3">
					Additionally, I was part of the Malibu congregation during its many discussions of
					women’s roles in worship. I remember, especially, a night when the elders invited
					the women to come together and talk frankly to them about our own feelings about
					expanded participation. I remember telling them that since we had been talking about
					this for years, and since I was already in my fifties, I wondered if time would run
					out for me. I expressed doubt that I would ever have such an opportunity within this
					fellowship. But after years of discussion, the elders decided that in an effort to
					be more biblical, they should offer expanded opportunities for women’s participation.
					And so, for the first time, I read Scripture aloud in public worship. For the first
					time, I served at the communion table. </p>
<p id="pz16-4">
					These gradual changes have not come without pain. Some of my own peers who thought
					that women should not participate at all called those <span id="z17-1">of us who did participate “whores.”
					Compromisers of integrity. My own policy has been this: “If asked, I will serve.”
					</span></p>
<p id="pz17-2">
					Through all of these days and months and years of increased involvement, my father
					never heard me speak. In fact, he would probably have been uncomfortable with some
					of my activities. But in one of my very last visits with him before his death in
					1996, I took him a copy of a speech that I had prepared for the 1994 Pepperdine lectureship.
					It was entitled, “Memory Is the Power to Gather Roses in Winter.” </p>
<p id="pz17-3">
					In this piece, I explored the aftermath of a year of fire and flood and earthquake
					in Southern California—a year in which more than once we thought that we might lose
					our home and all of its contents. All of our precious mementos—from photographs to
					quilts—were threatened with destruction. I wrote about how I would mourn their loss,
					but also about how I could cherish and tend the memory of those treasured items.
					</p>
<p id="pz17-4">
					And then, before the winter was over, I was faced with the serious illness of my
					father. It appeared that Daddy was losing memory and that he (and we) might be facing
					Alzheimer’s. Even though the altered memory turned out to be only a temporary condition,
					it caused me to realize that in the end, I couldn’t even count on memory. I was finally
					forced to acknowledge and to write that in the end, all I can really count on is
					the memory of God. I know that no matter what happens in life or in death, God will
					not forget me, for I am held in the precious memory of God who has redeemed me and
					calls me his child. </p>
<p id="pz17-5">
					It was this speech that I took to my daddy. I wanted to share this part of my faith
					journey with him, so I sat at his kitchen table and talked with him about my presentation.
					I held its complete text in my hands. He reached for it and said that he looked forward
					to reading it. But I gently rebuffed him and said, “No, I want to read it <i>to</i> you.”
					And so we sat, father and daughter. Page after page, I read. And for the first time,
					and the last, he heard my voice. And I think he knew, though somewhat tardily and
					certainly incompletely, that this son who would walk in his footsteps, this Timothy
					he had longed for, was not a son at all. This Timothy was his daughter. </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter05.vue?8ef21a7e